import el from './translation'

//Write here all the changes to translations that are not correct
el.label.dark = 'σκούρο'
el.label.light = 'φως'
el.label.standard = 'Ρύθμιση συστήματος'
el.object.light = 'φως'
el.messages.cart.amountItems = "{amount} μεμονωμένο στοιχείο"
el.messages.cart.amount = "{amount} θέσεις στοιχείων"

export default el
